// extracted by mini-css-extract-plugin
export var searchBoxContainer = "styles-module__searchBoxContainer___LICCS";